var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUkranianFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#0057B7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 400,
    y: 400,
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkranianFlag);
export default __webpack_public_path__ + "static/media/ukranian-flag.4711f40c46179ad6feed89202d625181.svg";
export { ForwardRef as ReactComponent };